import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog';

import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.use(VuejsDialog, {
  html: true,
  loader: true,
  animation: 'fade',
  backdropClose: true,
  customClass: ['confirm', 'new-dialog', 'column-footer-reverse'],
});
